'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dAvailable$002dCredentials from "./presto.types$proto$-Available-Credentials.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$AvailableCredentials$() {
}
export { $c_Lpresto_types$proto$AvailableCredentials$ as $c_Lpresto_types$proto$AvailableCredentials$ };
$p = $c_Lpresto_types$proto$AvailableCredentials$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$AvailableCredentials$;
/** @constructor */
function $h_Lpresto_types$proto$AvailableCredentials$() {
}
export { $h_Lpresto_types$proto$AvailableCredentials$ as $h_Lpresto_types$proto$AvailableCredentials$ };
$h_Lpresto_types$proto$AvailableCredentials$.prototype = $p;
$p.l = (function() {
  return "AvailableCredentials";
});
$p.cGM = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dAvailable$002dCredentials.$c_Lpresto_types$proto$AvailableCredentials(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$proto$AvailableCredentials$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$AvailableCredentials$, "presto.types$proto$AvailableCredentials$", ({
  a2Z: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$AvailableCredentials$ as $d_Lpresto_types$proto$AvailableCredentials$ };
var $n_Lpresto_types$proto$AvailableCredentials$;
function $m_Lpresto_types$proto$AvailableCredentials$() {
  if ((!$n_Lpresto_types$proto$AvailableCredentials$)) {
    $n_Lpresto_types$proto$AvailableCredentials$ = new $c_Lpresto_types$proto$AvailableCredentials$();
  }
  return $n_Lpresto_types$proto$AvailableCredentials$;
}
export { $m_Lpresto_types$proto$AvailableCredentials$ as $m_Lpresto_types$proto$AvailableCredentials$ };
//# sourceMappingURL=presto.types$proto$-Available-Credentials$.js.map
